"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2725],{

/***/ 3475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7379);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3887);

// styles

function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: ",
        "px;\n  max-width: 100%;\n  min-height: calc(100vh - 56px); // - header\n  margin: 0 auto;\n\n  ",
        " {\n    min-height: calc(100vh - 84px); // - header\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
/**
 * 메인 레이아웃
 */ var MainLayout = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-690443c4-0"
})(_templateObject(), _styles__WEBPACK_IMPORTED_MODULE_0__/* .mediaValue.medium */ .T8.medium, _styles__WEBPACK_IMPORTED_MODULE_0__/* .mediaQuery.large */ .cy.large);
/* harmony default export */ __webpack_exports__["Z"] = (MainLayout);


/***/ }),

/***/ 5734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7379);
/* harmony import */ var lib_styles_animations__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1751);
/* harmony import */ var cds_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3887);


// styles


function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  margin: 0px auto;\n  width: ",
        ";\n\n  &:before {\n    content: '';\n    display: block;\n    padding-top: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  animation: ",
        " 1.6s linear infinite;\n  height: 100%;\n  transform-origin: center center;\n  width: 100%;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin: auto;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  stroke: ",
        ";\n  stroke-width: 4;\n  stroke-miterlimit: 10;\n  stroke-dasharray: 1, 200;\n  stroke-dashoffset: 0;\n  stroke-linecap: round;\n  fill: none;\n  animation: ",
        " 1.2s ease-in-out infinite;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
/**
 * 로딩
 * @param {object} props
 * @param {number} props.size
 * @param {string} props.color
 */ var SpinLoading = function(param) {
    var _size = param.size, size = _size === void 0 ? 36 : _size, _color = param.color, color = _color === void 0 ? cds_styles__WEBPACK_IMPORTED_MODULE_2__/* .palette.red040 */ .DG.red040 : _color;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Loader, {
        size: size,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Svg, {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "25 25 50 50",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CirclePath, {
                cx: "50",
                cy: "50",
                r: "20",
                color: color
            })
        })
    }));
};
var Loader = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b538cb9d-0"
})(_templateObject(), function(param) {
    var size = param.size;
    return "".concat(size, "px");
});
var Svg = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].svg.withConfig */ .ZP.svg.withConfig({
    componentId: "sc-b538cb9d-1"
})(_templateObject1(), lib_styles_animations__WEBPACK_IMPORTED_MODULE_1__/* .spin */ .O2);
var CirclePath = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].circle.withConfig */ .ZP.circle.withConfig({
    componentId: "sc-b538cb9d-2"
})(_templateObject2(), function(param) {
    var color = param.color;
    return color;
}, lib_styles_animations__WEBPACK_IMPORTED_MODULE_1__/* .dashLoad */ .tG);
/* harmony default export */ __webpack_exports__["Z"] = (SpinLoading);


/***/ }),

/***/ 7068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7379);
/* harmony import */ var cds_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6643);
/* harmony import */ var cds_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3887);


// components

// styles

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  width: 4px;\n  height: 4px;\n  top: -2px;\n  right: -2px;\n  border-radius: 4px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  min-width: 16px;\n  height: 16px;\n  top: 0;\n  left: ",
        ";\n  padding: 0 4px;\n  border: 1px solid white;\n  border-radius: 16px;\n  background-color: ",
        ";\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 14px;\n  text-align: center;\n  color: white;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
/**
 * 알림 아이콘
 * @param {object} props
 * @param {number=} props.width 가로길이
 * @param {number=} props.height 세로길이
 * @param {boolean=} props.isActive 활성화 여부
 * @param {number=} props.count 읽지 않은 알림 개수
 */ var NotifyIcon = function(_param) {
    var _width = _param.width, width = _width === void 0 ? 32 : _width, _height = _param.height, height = _height === void 0 ? 32 : _height, isActive = _param.isActive, count = _param.count, _name = _param.name, name = _name === void 0 ? 'ic_alarm_s' : _name, props = _objectWithoutProperties(_param, [
        "width",
        "height",
        "isActive",
        "count",
        "name"
    ]);
    var countMessage = count > 99 ? '99+' : count;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("i", {
        style: {
            position: 'relative',
            display: 'inherit'
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(cds_icons__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _objectSpread({
                name: name,
                width: width,
                height: height
            }, props)),
            isActive && !count && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BadgeCircle, {}),
            !!count && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Badge, {
                className: "noselect",
                width: width,
                children: countMessage
            })
        ]
    }));
};
var BadgeCircle = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-976ba437-0"
})(_templateObject(), cds_styles__WEBPACK_IMPORTED_MODULE_2__/* .palette.red040 */ .DG.red040);
var Badge = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-976ba437-1"
})(_templateObject1(), function(param) {
    var width = param.width;
    return "calc(".concat(width, "px / 2)");
}, cds_styles__WEBPACK_IMPORTED_MODULE_2__/* .palette.red040 */ .DG.red040);
/* harmony default export */ __webpack_exports__["Z"] = (NotifyIcon);


/***/ }),

/***/ 2372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7379);
/* harmony import */ var cds_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6643);
/* harmony import */ var cds_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3887);


// icons

// styles

function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 12px;\n  font-weight: 500;\n  color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 2px;\n  font-size: 14px;\n  color: ",
        ";\n  letter-spacing: -0.25px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
/**
 * 비어있는 컨텐츠일 때, 표시하는 컴포넌트
 * @param {object} props
 * @param {string} props.icon 아이콘 명
 * @param {number} props.w 아이콘 가로 길이
 * @param {number} props.h 아이콘 세로 길이
 * @param {JSX.Element} props.title
 * @param {JSX.Element} props.body
 */ var EmptyContent = function(param) {
    var icon = param.icon, _w = param.w, w = _w === void 0 ? 52 : _w, _h = param.h, h = _h === void 0 ? 52 : _h, title = param.title, body = param.body, children = param.children;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(cds_icons__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                name: icon,
                width: w,
                height: h,
                fill: cds_styles__WEBPACK_IMPORTED_MODULE_2__/* .palette.grey50 */ .DG.grey50
            }),
            children && children,
            !children && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Body, {
                        children: body
                    })
                ]
            })
        ]
    }));
};
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-dbb5c9ab-0"
})(_templateObject());
var Title = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].strong.withConfig */ .ZP.strong.withConfig({
    componentId: "sc-dbb5c9ab-1"
})(_templateObject1(), cds_styles__WEBPACK_IMPORTED_MODULE_2__/* .palette.font.tertiary1 */ .DG.font.tertiary1);
var Body = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-dbb5c9ab-2"
})(_templateObject2(), cds_styles__WEBPACK_IMPORTED_MODULE_2__/* .palette.grey0 */ .DG.grey0);
/* harmony default export */ __webpack_exports__["Z"] = (EmptyContent);


/***/ }),

/***/ 2747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_NotificationCenter; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(7379);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
// EXTERNAL MODULE: ./src/cds/icons/index.tsx
var icons = __webpack_require__(6643);
// EXTERNAL MODULE: ./src/slices/user.thunk.js + 1 modules
var user_thunk = __webpack_require__(9001);
// EXTERNAL MODULE: ./src/hooks/common/useStore.ts
var useStore = __webpack_require__(8004);
// EXTERNAL MODULE: ./src/cds/styles.ts
var styles = __webpack_require__(3887);
// EXTERNAL MODULE: ./src/lib/utils/deviceChecker.js
var deviceChecker = __webpack_require__(7496);
;// CONCATENATED MODULE: ./src/components/molecules/common/Notification.js



// components

// slices

// hooks

// styles



function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding: 8px 4px 8px 12px;\n  background-color: ",
        ";\n  cursor: pointer;\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  width: 40px;\n  height: 40px;\n  border-radius: 100%;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover;\n  background-image: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: 12px;\n  height: 12px;\n  border-radius: 100%;\n  background-repeat: no-repeat;\n  background-position: 100%;\n  background-size: cover;\n  background-image: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  flex: 1;\n  width: auto;\n  padding: 8px 0;\n  margin-left: 12px;\n  line-height: 12px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  margin-bottom: 4px;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 16px;\n  word-break: break-word;\n  word-wrap: break-word;\n  white-space: pre-wrap;\n  color: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 10px;\n  color: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 10px;\n  color: ",
        ";\n\n  &::before {\n    content: '\\B7';\n    display: inline-block;\n    margin: 0 4px;\n  }\n"
    ], [
        "\n  font-size: 10px;\n  color: ",
        ";\n\n  &::before {\n    content: '\\\\B7';\n    display: inline-block;\n    margin: 0 4px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  opacity: 0.4;\n\n  ",
        " {\n    &:hover {\n      opacity: 1;\n    }\n  }\n\n  &:active {\n    opacity: 1;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
/**
 * 단일 알림
 * @param {object} props
 * @param {import('types/slices/user').Notify} props.noti 알림 정보
 */ var Notification = function(param) {
    var noti = param.noti;
    var ref;
    var dispatch = (0,useStore/* useDispatch */.I)();
    var myId = (0,useStore/* useSelector */.v)(function(state) {
        return state.user.info.id;
    });
    var ref1 = (0,react.useState)(false), isApp = ref1[0], setIsApp = ref1[1];
    /** 아이콘 타입 */ var iconType = {
        1: "".concat("https://cdn.classu.co.kr", "/img/class/notification/ic_noti_attend.png"),
        2: "".concat("https://cdn.classu.co.kr", "/img/class/notification/ic_noti_add_friend.png"),
        3: "".concat("https://cdn.classu.co.kr", "/img/class/notification/ic_noti_alarm.png")
    };
    /** 알림 타입 */ var pushType = {
        0: "".concat(noti.push_url),
        1: "".concat("https://www.classu.co.kr", "/class/lecture/").concat(noti.mcClass_id),
        2: "/community/".concat(noti.mcComment_id),
        3: "/community/".concat(noti.mcComment_id),
        4: "/user/".concat(noti.friend_id),
        5: "".concat("https://www.classu.co.kr", "/"),
        6: "/user/".concat(myId),
        7: "",
        8: "".concat("https://www.classu.co.kr", "/class/chat/").concat(noti.friend_id),
        9: "",
        10: "".concat("https://www.classu.co.kr", "/class/lecture/").concat(noti.mcClass_id),
        11: "".concat(noti.push_url),
        12: "".concat(noti.push_url),
        13: "".concat(noti.push_url),
        14: "".concat(noti.push_url)
    };
    var onRead = function() {
        dispatch((0,user_thunk/* readNotification */.iG)({
            notifyId: noti.id,
            readStatus: noti.read_status
        }));
    };
    var onRemove = function(e) {
        e.stopPropagation();
        dispatch((0,user_thunk/* removeNotification */.FV)({
            notifyId: noti.id,
            readStatus: noti.read_status
        }));
    };
    (0,react.useEffect)(function() {
        var device = (0,deviceChecker/* default */.Z)();
        if (device.app()) {
            return setIsApp(true);
        }
        setIsApp(false);
    }, []);
    var isExternal = (ref = noti.push_url) === null || ref === void 0 ? void 0 : ref.includes('webview/external');
    var hasRedirectURL = isExternal && noti.push_url.includes('?');
    var redirectURL = hasRedirectURL && noti.push_url.split('?')[1].replace('redirect=', '');
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout, {
        isRead: noti.read_status === 'Y',
        onClick: onRead,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                href: "/user/".concat(noti.friend_id),
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Profile, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Photo, {
                            url: noti.photo
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge, {
                            url: iconType[noti.icon_type]
                        })
                    ]
                })
            }),
            isExternal ? hasRedirectURL ? /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                href: redirectURL,
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                    target: "_blank",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                            children: noti.body
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Name, {
                            children: noti.short_name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Time, {
                            children: noti.time_spilled
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                href: noti.push_type < 15 ? pushType[noti.push_type] : noti.push_url,
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                    target: "_blank",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                            children: noti.body
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Name, {
                            children: noti.short_name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Time, {
                            children: noti.time_spilled
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                href: noti.push_type < 15 ? pushType[noti.push_type] : noti.push_url,
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                            children: noti.body
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Name, {
                            children: noti.short_name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Time, {
                            children: noti.time_spilled
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton, {
                onClick: onRemove,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                    name: "ic_close_m",
                    width: "16",
                    height: "16",
                    fill: styles/* palette.grey25 */.DG.grey25
                })
            })
        ]
    }));
};
var Layout = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-44e846b4-0"
})(_templateObject(), function(param) {
    var isRead = param.isRead;
    return isRead ? '' : styles/* palette.BTN.BG */.DG.BTN.BG;
}, styles/* palette.BTN.BG */.DG.BTN.BG);
var Profile = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-44e846b4-1"
})(_templateObject1());
var Photo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-44e846b4-2"
})(_templateObject2(), function(param) {
    var url = param.url;
    return "url(".concat(url, ")");
});
var Badge = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-44e846b4-3"
})(_templateObject3(), function(param) {
    var url = param.url;
    return "url(".concat(url, ")");
});
var Content = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-44e846b4-4"
})(_templateObject4());
var Title = styled_components_browser_esm/* default.strong.withConfig */.ZP.strong.withConfig({
    componentId: "sc-44e846b4-5"
})(_templateObject5(), styles/* palette.grey50 */.DG.grey50);
var Name = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-44e846b4-6"
})(_templateObject6(), styles/* palette.grey25 */.DG.grey25);
var Time = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-44e846b4-7"
})(_templateObject7(), styles/* palette.font.tertiary2 */.DG.font.tertiary2);
var CloseButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-44e846b4-8"
})(_templateObject8(), styles/* onlyHover */.kC);
/* harmony default export */ var common_Notification = (Notification);

// EXTERNAL MODULE: ./src/components/molecules/common/EmptyContent.js
var EmptyContent = __webpack_require__(2372);
// EXTERNAL MODULE: ./src/components/atoms/common/SpinLoading.js
var SpinLoading = __webpack_require__(5734);
// EXTERNAL MODULE: ./src/cds/layout/VerticalScroll.tsx
var VerticalScroll = __webpack_require__(498);
// EXTERNAL MODULE: ./src/hooks/common/useInfiniteScroll.js
var useInfiniteScroll = __webpack_require__(8970);
// EXTERNAL MODULE: ./src/hooks/common/useAccordingToScroll.js
var useAccordingToScroll = __webpack_require__(5571);
// EXTERNAL MODULE: ./src/lib/styles/animations.js
var animations = __webpack_require__(1751);
;// CONCATENATED MODULE: ./src/components/organisms/common/NotificationCenter.js




// components





// slices

// hooks



// styles


function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function NotificationCenter_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function NotificationCenter_templateObject() {
    var data = NotificationCenter_taggedTemplateLiteral([
        "\n  display: ",
        ";\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  max-width: 100%;\n  margin: auto;\n  z-index: ",
        ";\n\n  ",
        " {\n    bottom: auto;\n    width: 1368px;\n    max-width: calc(100% - 32px);\n  }\n\n  ",
        " {\n    bottom: auto;\n    width: 100%;\n  }\n"
    ]);
    NotificationCenter_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NotificationCenter_templateObject1() {
    var data = NotificationCenter_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  max-width: 100%;\n  height: 90vh;\n  min-height: 90vh;\n  background-color: ",
        ";\n  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.1);\n  animation: 0.2s ",
        " ease;\n  transform-origin: top;\n  overflow: hidden;\n\n  ",
        " {\n    top: 68px;\n    right: 0;\n    left: auto;\n    max-width: 360px;\n    margin-top: 4px;\n    border-radius: 12px;\n    min-height: 440px;\n  }\n\n  ",
        " {\n    max-height: calc(600px);\n    right: 0;\n    margin-left: auto;\n    z-index: ",
        ";\n    transition: 0.2s ease;\n    transform: ",
        ";\n  }\n"
    ]);
    NotificationCenter_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function NotificationCenter_templateObject2() {
    var data = NotificationCenter_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 4px 8px 12px;\n  border-bottom: 1px solid ",
        ";\n\n  & > div {\n    display: flex;\n    align-items: center;\n  }\n"
    ]);
    NotificationCenter_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function NotificationCenter_templateObject3() {
    var data = NotificationCenter_taggedTemplateLiteral([
        "\n  font-size: 18px;\n  font-weight: 500;\n  color: ",
        ";\n"
    ]);
    NotificationCenter_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function NotificationCenter_templateObject4() {
    var data = NotificationCenter_taggedTemplateLiteral([
        "\n  font-size: 12px;\n  color: ",
        ";\n  transition: 0.1s ease;\n\n  & > svg {\n    display: list-item;\n    margin: 8px;\n  }\n\n  & ~ & {\n    margin-left: 12px;\n  }\n"
    ]);
    NotificationCenter_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function NotificationCenter_templateObject5() {
    var data = NotificationCenter_taggedTemplateLiteral([
        "\n  flex: 1;\n  position: relative;\n  overflow-y: auto;\n\n  & > li {\n    white-space: normal;\n  }\n"
    ]);
    NotificationCenter_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function NotificationCenter_templateObject6() {
    var data = NotificationCenter_taggedTemplateLiteral([
        "\n  min-height: 100%;\n"
    ]);
    NotificationCenter_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function NotificationCenter_templateObject7() {
    var data = NotificationCenter_taggedTemplateLiteral([
        "\n  margin-top: -64px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 12px 0 24px 0;\n"
    ]);
    NotificationCenter_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function NotificationCenter_templateObject8() {
    var data = NotificationCenter_taggedTemplateLiteral([
        "\n  display: flex;\n  align-content: center;\n  justify-content: center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  margin: auto auto 60px;\n"
    ]);
    NotificationCenter_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
/**
 * 알림 센터
 * @param {object} props
 * @param {object} props.isVisible 표시 여부
 * @param {Function} props.onClose 알림 닫기
 */ var NotificationCenter = function(param1) {
    var isVisible = param1.isVisible, onClose = param1.onClose;
    var dispatch = (0,useStore/* useDispatch */.I)();
    var notificationList = (0,useStore/* useSelector */.v)(function(state) {
        return state.user.notificationList;
    });
    var notificationInfo = (0,useStore/* useSelector */.v)(function(state) {
        return state.user.notificationInfo;
    });
    var existNotification = (0,useStore/* useSelector */.v)(function(state) {
        return state.user.newsCount.news_unread_count;
    });
    var ref = (0,react.useState)(true), isLoading = ref[0], setIsLoading = ref[1];
    var enableMoreData = (0,react.useRef)(true);
    var target = (0,react.useRef)(null);
    var ref1 = _slicedToArray((0,useAccordingToScroll/* default */.Z)({
        start: 84
    }), 2), stickyRef = ref1[0], isSticky = ref1[1];
    (0,useInfiniteScroll/* default */.Z)({
        target: target,
        onIntersect: function(param) {
            var _param = _slicedToArray(param, 1), entry = _param[0];
            if (entry.isIntersecting) {
                onLoadData();
            }
        }
    });
    /** 알림 전체 읽기  */ var onReadAll = function() {
        if (existNotification === 0) {
            return;
        }
        dispatch((0,user_thunk/* readAllNotification */.qw)());
    };
    /** 알림 전체 제거 */ var onRemoveall = function() {
        if (notificationList.length === 0) {
            return;
        }
        dispatch((0,user_thunk/* removeAllNotification */.oN)());
    };
    /** 알림 데이터 호출 함수 */ var onLoadData = (0,react.useCallback)(_asyncToGenerator(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (enableMoreData.current) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 2:
                    if (!(notificationInfo.nextPage > notificationInfo.total_page)) {
                        _ctx.next = 5;
                        break;
                    }
                    setIsLoading(false);
                    return _ctx.abrupt("return");
                case 5:
                    setIsLoading(true);
                    enableMoreData.current = false;
                    _ctx.next = 9;
                    return dispatch((0,user_thunk/* getNotificationList */.Jq)({
                        page: notificationInfo.nextPage
                    })).catch(function() {});
                case 9:
                    res = _ctx.sent;
                    setIsLoading(false);
                    if (res.payload && res.payload.length) {
                        enableMoreData.current = true;
                    }
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        dispatch,
        notificationInfo
    ]);
    /** 알림센터 클릭 끄기 이벤트 작업 */ /* eslint-disable */ (0,react.useEffect)(function() {
        if (!isVisible) {
            return;
        }
        var onClickScreen = function(e) {
            var path = e.path || e.composedPath && e.composedPath();
            if (!path) {
                return;
            }
            if (!path.includes(stickyRef.current)) {
                onClose();
            }
        };
        document.addEventListener('click', onClickScreen);
        return function() {
            return document.removeEventListener('click', onClickScreen);
        };
    }, [
        isVisible
    ]);
    /* eslint-enable */ var NotiList = notificationList.map(function(noti, idx) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Notification, {
                noti: noti
            })
        }, "noti._id-".concat(idx));
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationLayout, {
        isVisible: isVisible,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NotificationCenter_Layout, {
            isVisible: isVisible,
            isSticky: isSticky,
            ref: stickyRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationCenter_Title, {
                            children: "알림"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ActiveButton, {
                                    active: existNotification > 0,
                                    onClick: onReadAll,
                                    children: "전체읽기"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ActiveButton, {
                                    active: NotiList.length > 0,
                                    onClick: onRemoveall,
                                    children: "전체삭제"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ActiveButton, {
                                    onClick: onClose,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                        name: "ic_close_m",
                                        width: "18",
                                        height: "18",
                                        fill: styles/* palette.grey50 */.DG.grey50
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Body, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyContent, {
                            children: [
                                NotiList,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    ref: target
                                })
                            ]
                        }),
                        !NotiList.length && !isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyLayout, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyContent/* default */.Z, {
                                icon: "ic_alarm_s",
                                w: 52,
                                h: 52,
                                title: "알림이 없어요",
                                body: "새로운 소식이 들어오면 알려드릴게요"
                            })
                        }),
                        isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingLayout, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpinLoading/* default */.Z, {})
                        })
                    ]
                })
            ]
        })
    }));
};
var NotificationLayout = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a087c062-0"
})(NotificationCenter_templateObject(), function(param) {
    var isVisible = param.isVisible;
    return isVisible ? 'block' : 'none';
}, styles/* zIndex.notification */.W5.notification, styles/* mediaQuery.small */.cy.small, styles/* mediaQuery.large */.cy.large);
var NotificationCenter_Layout = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a087c062-1"
})(NotificationCenter_templateObject1(), styles/* palette.system.BNB */.DG.system.BNB, animations/* notificationOpen */.W_, styles/* mediaQuery.small */.cy.small, styles/* mediaQuery.large */.cy.large, styles/* zIndex.notification */.W5.notification, function(param) {
    var isSticky = param.isSticky;
    return isSticky ? 'translateY(-64px)' : 'translateY(0)';
});
var Header = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a087c062-2"
})(NotificationCenter_templateObject2(), styles/* palette.BTN.BG */.DG.BTN.BG);
var NotificationCenter_Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-a087c062-3"
})(NotificationCenter_templateObject3(), styles/* palette.grey75 */.DG.grey75);
var ActiveButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-a087c062-4"
})(NotificationCenter_templateObject4(), function(param) {
    var active = param.active;
    return active ? styles/* palette.grey50 */.DG.grey50 : styles/* palette.grey0 */.DG.grey0;
});
var Body = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-a087c062-5"
})(NotificationCenter_templateObject5());
var BodyContent = (0,styled_components_browser_esm/* default */.ZP)(VerticalScroll/* default */.Z).withConfig({
    componentId: "sc-a087c062-6"
})(NotificationCenter_templateObject6());
var LoadingLayout = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a087c062-7"
})(NotificationCenter_templateObject7());
var EmptyLayout = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a087c062-8"
})(NotificationCenter_templateObject8());
/* harmony default export */ var common_NotificationCenter = (NotificationCenter);


/***/ }),

/***/ 5571:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var hooks_common_event_useThrottle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2567);
/* harmony import */ var lib_utils_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3090);

// hooks

// utils

/**
 * 스크롤에 따른 fixed - DOM을 조작한다.
 * @param {object} param
 * @param {number} start 스크롤 이벤트 시작위치, 0일 경우 해당 참조 요소 높이
 * const [stickyRef, isSticky] = useAccordingToScroll({ start: 0 });
 * <div ref={stickyRef} isSticky={isSticky} />
 */ var useAccordingToScroll = function(param) {
    var _start = param.start, start = _start === void 0 ? 0 : _start;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isSticky = ref[0], setIsSticky = ref[1];
    var stickyRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var prevY = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);
    var prevDirection = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);
    var currentScroll = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);
    var direction1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);
    var throttle = (0,hooks_common_event_useThrottle__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    var handleScroll = function(direction) {
        if (direction === 2) {
            setIsSticky(true);
            prevDirection.current = direction;
        } else if (direction === 1) {
            setIsSticky(false);
            prevDirection.current = direction;
        }
    };
    var onScroll = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        currentScroll.current = (0,lib_utils_dom__WEBPACK_IMPORTED_MODULE_2__/* .getScrollTop */ .cx)();
        var isFixedVisible = start;
        if (!start && stickyRef.current) {
            isFixedVisible = stickyRef.current.offsetHeight;
        }
        if (currentScroll.current >= isFixedVisible) {
            direction1.current = 1;
            if (currentScroll.current > prevY.current) {
                direction1.current = 2;
            } else {
                direction1.current = 1;
            }
        } else {
            direction1.current = 1;
        }
        if (direction1.current !== prevDirection.current) {
            handleScroll(direction1.current);
        }
        prevY.current = currentScroll.current;
    }, [
        start
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!stickyRef.current) {
            return;
        }
        var throttled = throttle.run(onScroll, 500);
        window.addEventListener('scroll', throttled);
        return function() {
            throttle.cleanUp();
            window.removeEventListener('scroll', throttled);
        };
    }, [
        onScroll,
        stickyRef
    ]);
    return [
        stickyRef,
        isSticky
    ];
};
/* harmony default export */ __webpack_exports__["Z"] = (useAccordingToScroll);


/***/ }),

/***/ 8970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

/**
 * Infinite Scroll hook
 * @param {object} props
 * @param {NodeElement | null=} props.root 뷰포트 Element
 * @param {NodeElement | null} props.target 탐지 타겟 Element
 * @param {IntersectionObserverCallback} props.onIntersect 감지 콜백 함수
 * @param {number=} props.threshold 교차 범위
 *
 * @example
 * const target = useRef(null);
 * const enableMoreData = useRef(true);
 *
 * useInfiniteScroll({
 *   target,
 *   onIntersect: ([entry]) => {
 *     if (entry.isIntersecting) {
 *       onLoadData();
 *     }
 *   }
 * });
 *
 * const onLoadData = useCallback(async () => {
 *   if (!enableMoreData.current) {
 *     return;
 *   }
 *
 * 	 enableMoreData.current = false;
 *   const data = await api.sampleData();
 *
 *   if (data.payload) {
 *     enableMoreData.current = true;
 *   }
 * }, []);
 *
 * return(
 *   <>
 *     <Item />
 *     <Item />
 *     <Item />
 *     <LastItem ref={target} />
 *   </>
 * );
 */ var useInfiniteScroll = function(param) {
    var _root = param.root, root = _root === void 0 ? null : _root, target = param.target, onIntersect = param.onIntersect, _threshold = param.threshold, threshold = _threshold === void 0 ? 0 : _threshold;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var observer = new IntersectionObserver(onIntersect, {
            root: root,
            threshold: threshold
        });
        var targetDom = target.current;
        if (!targetDom) {
            return;
        }
        observer.observe(targetDom);
        return function() {
            return observer && observer.unobserve(targetDom);
        };
    }, [
        target,
        root,
        onIntersect,
        threshold
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useInfiniteScroll);


/***/ })

}]);